import {toUiMsg$} from '@/ui';
import {positionNotification$} from './notification-contract-position';

export interface UNotificationContractPosition {
  type: 'notification-position';
  data: any;
}

export function subscribeNotificationContractPosition() {
  positionNotification$.subscribe((data) => toUiMsg$.next({type: 'notification-position', data}));
}
